import { getApiBase } from "../utils/env";

async function fetchWithAuth(url, token, options = {}) {
  const headers = options.headers || {};
  if (token) headers["Authorization"] = `Bearer ${token}`;
  headers["Content-Type"] = headers["Content-Type"] || "application/json";
  const res = await fetch(url, { ...options, headers });
  const txt = await res.text();
  let json = null;
  try { json = txt ? JSON.parse(txt) : null; } catch { json = txt; }
  if (!res.ok) {
    const errMsg = json?.message || json?.error || (typeof json === "string" ? json : `HTTP ${res.status}`);
    throw new Error(errMsg);
  }
  return json;
}

/**
 * GET /api/license/status
 * Anonymous — returns the current license status DTO.
 */
export async function getLicenseStatus() {
  const url = `${getApiBase()}/api/license/status`;
  const res = await fetch(url, { headers: { "Content-Type": "application/json" } });
  if (!res.ok) throw new Error(`License status fetch failed: HTTP ${res.status}`);
  return res.json();
}

/**
 * POST /api/license
 * Admin only — uploads a new .dls license (raw JWS string).
 */
export async function uploadLicense(rawJws, token) {
  return fetchWithAuth(`${getApiBase()}/api/license`, token, {
    method: "POST",
    body: JSON.stringify({ rawJws }),
  });
}

/**
 * POST /api/license/reload
 * Admin only — force-reloads the license from the DB.
 */
export async function reloadLicense(token) {
  return fetchWithAuth(`${getApiBase()}/api/license/reload`, token, {
    method: "POST",
  });
}
